import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
export function getPrimaryLocation(locations) {
  if (_isEmpty(locations)) {
    return null;
  }
  var location = _find(locations, function (_ref) {
    var primaryLocation = _ref.primaryLocation;
    return primaryLocation;
  });
  return location || locations[0];
}
export function getLocationById(locations, locationId) {
  if (_isEmpty(locations)) {
    return null;
  }
  var location = _find(locations, function (_ref2) {
    var id = _ref2.id;
    return id === locationId;
  });
  return location;
}
export function getLocationStorageKey(siteId) {
  return "active-location_".concat(siteId);
}